package com.hipsheep.kore.viewmodel

// TODO: Implement custom code that imitates what AndroidX's ViewModel does???
public actual abstract class ViewModel actual constructor() {

    protected actual open fun onDestroy() {
    }

}